import $i from "~/i18n";

export const getInst = async ({ commit, dispatch }, payload) => {
  let { data } = await axios.post("/course-insts/get", {
    course_id: payload.id
  });
  if (data.instructors.length > 0) {
    data.instructors.forEach(e => {
      dispatch("getInstractor", e.user_id);
    });
  }
};

export const removeTrue = async (context, payload) => {
  context.commit("removeTrue", payload);
};
export const removeFalse = async (context, payload) => {
  context.commit("removeFalse", payload);
};
export const getAllTrue = async ({ commit }, payload) => {
  try {
    commit("clear");
    let { data } = await axios.post("/become-instructor/get", {
      isActive: true,
      page_num: payload.page
    });
    if (data.state !== 200) return;
    commit("SET_DATA", {
      id: "lengthListInstructorActive",
      data: data.instrustors_list.length
    });
    if (data.instrustors_list.length > 0) {
      commit("setInstructors", data.instrustors_list);
    }
  } catch (error) {
    console.log(error);
  }
};
export const getAllFalse = async ({ commit }, payload) => {
  try {
    commit("clear");
    let { data } = await axios.post("/become-instructor/get", {
      isActive: false
    });
    if (data.state !== 200) return;
    commit("SET_DATA", {
      id: "lengthListInstructorDeActive",
      data: data.instrustors_list.length
    });
    if (data.instrustors_list.length > 0) {
      commit("setInstructorsDactive", data.instrustors_list);
    }
  } catch (error) {
    console.log(error);
  }
};
export const getCoursePublish = async ({ commit, state }, payload) => {
  try {
    let { data } = await axios.post("/course/get-course-list", { ...payload });
    if (data.state !== 200) return;
    commit("SET_DATA", { data: data.course_list.length, id: "lengthListPub" });
    if (state.lengthListPub > 0) {
      commit("SET_DATA", { data: data.course_list, id: "coursePublish" });
    }
  } catch (error) {
    console.log(error);
  }
};
export const getCourseUnPublish = async ({ commit, state }, payload) => {
  try {
    let { data } = await axios.post("/course/get-course-list", {
      ...payload
    });
    if (data.state !== 200) return;
    commit("SET_DATA", {
      data: data.course_list.length,
      id: "lengthListUnPub"
    });
    if (state.lengthListUnPub > 0) {
      commit("SET_DATA", {
        data: data.course_list,
        id: "courseUnpublish"
      });
    }
  } catch (error) {
    console.log(error);
  }
};
export const activeteInstructor = async ({ commit, state }, payload) => {
  let { data } = await axios.post("/become-instructor/activate", {
    active: payload.active,
    id: payload.id
  });
  if (data.state !== 200) {
    commit(
      "notifications/error",
      {
        message: $i.t("message.request.someProblem"),
        title: ""
      },
      { root: true }
    );
    return;
  }
  if (!payload.active) {
    commit("REMOVE_INDEX", { id: "instructors", index: payload.index });
  } else {
    commit("REMOVE_INDEX", {
      id: "instructorsDactive",
      index: payload.index
    });
  }
  commit(
    "notifications/success",
    { message: $i.t("message.request.done"), title: "" },
    { root: true }
  );
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/all-courses/actions.js